<template>
    <div class="trace">
        <Form :label-width="100" @keydown.native.enter.prevent="keyDownEvent">
            <FormItem label="字母">
                <Tag
                    v-for="item in letterList"
                    :key="item"
                    :name="item"
                    closable
                    @on-close="close"
                >{{item}}</Tag>
                <Input
                    style="width: 25%"
                    v-model="letter"
                    placeholder="请输入字母"
                    @keyup.enter.native="letterIpt"
                />
                <p>字母用回车分开</p>
            </FormItem>
        </Form>
    </div>
</template>
<style scoped>
</style>
<script>
import { Tag } from "iview";
export default {
    components: {
        Tag
    },
    data() {
        return {
            letterList: [],
            letter: "",
            info: {}
        };
    },
    props: ["stepData"],
    created() {
        this.init();
    },
    watch: {
        "stepData.data"() {
            this.init();
        }
    },
    methods: {
        init() {
            if (this.stepData) {
                this.info = this.stepData.data || {};
                this.letterList = this.info.list ? this.info.list : [];
                this.emitChangeData();
            }
        },
        keyDownEvent() {},
        close(event, name) {
            const index = this.letterList.indexOf(name);
            this.letterList.splice(index, 1);
        },
        letterIpt() {
            var _this = this;
            if (_this.letter) {
                _this.letterList.push(_this.letter);
                this.emitChangeData();
            } else {
                _this.$Message.warning("请先输入字母");
            }
            _this.letter = "";
        },
        emitChangeData() {
            let info = {
                list: this.letterList
            };
            this.$emit("changeData", info);
        }
    }
};
</script>